import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import * as constants from "./constants";
import commonUtils from "@/utils/common";
import messages from "@/locales/index";

export const state = {
  listRequests: constants.DEFAULT_LIST,
  request: {},
  singleRequest: {},
  clientsAdminList: constants.DEFAULT_LIST,
  clientAdminDetails: {},
  editUser: {},
  listChangeLog: constants.DEFAULT_LIST,
  listBlockedDomains: constants.DEFAULT_LIST,
  newBlockedDomain: {},
  listUsePolicy: constants.DEFAULT_LIST,
  activeUsePolicy: {
    data: {
      version: "N/A"
    }
  }
};

export const getters = {
  [constants.GETTERS_LIST_ALL_REQUESTS]: state => {
    return state.listRequests;
  },
  [constants.GETTERS_REQUEST]: state => {
    return state.request;
  },
  [constants.GETTERS_SINGLE_REQUESTS]: state => {
    return state.singleRequest;
  },
  [constants.GETTERS_CLIENTS_ADMIN_LIST]: state => {
    return state.clientsAdminList;
  },
  [constants.GETTERS_CLIENT_ADMIN_DETAILS]: state => {
    return state.clientAdminDetails;
  },
  [constants.GETTERS_EDIT_USER]: state => {
    return state.editUser;
  },
  [constants.GETTERS_LIST_CHANGE_LOG]: state => {
    return state.listChangeLog;
  },
  [constants.GETTERS_LIST_BLOCKED_DOMAINS]: state => {
    return state.listBlockedDomains;
  },
  [constants.GETTERS_BLOCKED_DOMAIN]: state => {
    return state.newBlockedDomain;
  },
  [constants.GETTERS_LIST_USE_POLICY]: state => {
    return state.listUsePolicy;
  },
  [constants.GETTERS_ACTIVE_USE_POLICY]: state => {
    return state.activeUsePolicy;
  }
};

export const actions = {
  [constants.ACTION_GET_ALL_REQUESTS]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.getListRequest;
    if (options.clientId) {
      url = getEndPoints().clientAdmin.getListRequestByClientId.replace(
        ":clientId",
        options.clientId
      );
    }
    url += "?orderBy=created_at&sortedBy=asc";
    if (options.status === "pending") {
      url += "&pending=1";
    }
    let params = options.pagination;
    params.limit = options.pagination.per_page;
    params.page = options.pagination.current_page;
    params.links = {};
    makeCall(url, buildOptions("GET", { params: params }), commit).then(
      response => {
        if (response) {
          response.data.forEach(o => {
            if (o.old_value && o.old_value.permissions) {
              o.old_value.permissions = commonUtils.convertPermissions(
                o.old_value.permissions
              );
            }
            if (o.new_value && o.new_value.permissions) {
              o.new_value.permissions = commonUtils.convertPermissions(
                o.new_value.permissions
              );
            }
            if (o.old_value === null) {
              o.old_value = {
                username: "",
                last_name: "",
                first_name: "",
                permissions: [],
                phone_number: ""
              };
            }
            if (o.new_value === null) {
              o.new_value = {
                username: "",
                last_name: "",
                first_name: "",
                permissions: [],
                phone_number: ""
              };
            }
          });
          commit(constants.MUTATION_SET_ALL_REQUESTS, response);
          if (options.callback) {
            options.callback();
          }
        }
      }
    );
  },

  [constants.ACTION_GET_REQUEST]: ({ commit }, options) => {
    if (!options.id) {
      return;
    }
    let url = getEndPoints().clientAdmin.getRequest.replace(":id", options.id);
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response) {
        commit(constants.MUTATION_SET_REQUEST, response);
        if (options.callback) {
          options.callback();
        }
      }
    });
  },

  [constants.ACTION_POST_REQUEST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().clientAdmin.postListRequest,
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : messages.getLocalizedString('changesSavedSuccessfully');
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        commit(constants.MUTATION_SET_SINGLE_REQUEST, response);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_RESEND_INVITATION_EMAIL]: ({ commit }, options) => {
    makeCall(
      getEndPoints().clientAdmin.resendInvitation.replace(
        ":userId",
        options.userId
      ),
      buildOptions("GET", {}),
      commit
    )
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Resend invitation email successfully";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_UPDATE_REQUEST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().clientAdmin.updateRequest.replace(":id", options.id),
      buildOptions("PUT", options.data),
      commit
    )
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Update successfully";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_POST_APPROVE_REQUEST]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.postApproveRequest.replace(
      ":requestId",
      options.requestId
    );
    if (options.isDeny) {
      url += "?deny=1";
    }
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Request approved";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_GET_LIST_CLIENT_PANEL]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.getListClientPanel.replace(
      ":clientId",
      options.clientId
    );
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response) {
        commit(constants.MUTATION_SET_LIST_CLIENT_PANEL, response);
        if (options.callback) {
          options.callback();
        }
      }
    });
  },

  [constants.ACTION_FILTER_LIST_USER]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.filterAdminPanel;
    if (options.clientId) {
      url = getEndPoints().clientAdmin.filterClientPanel.replace(
        ":clientId",
        options.clientId
      );
    }
    url = url.replace(
      "filterStr",
      options.params.search ? options.params.search : ""
    );
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response) {
        let permissionsObj = [];
        response.data.forEach(o => {
          o.permissions.data.forEach(item => {
            permissionsObj.push(item.name);
          });
          o.permissions.cookedData = commonUtils.convertPermissions(permissionsObj);
        });
        commit(constants.MUTATION_SET_FILTER_LIST_USER, response);
        if (options.callback) {
          options.callback();
        }
      }
    });
  },

  [constants.ACTION_GET_CLIENT_ADMIN_DETAIL]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.getUserDetails.replace(
      ":userId",
      options.userId
    );
    return new Promise((resolve, reject) => {
      makeCall(url, buildOptions("GET", options), commit)
        .then(response => {
          if (response) {
            let permissionsObj = [];
            response.data.permissions.data.forEach(item => {
              permissionsObj.push(item.name);
            });
            response.data.permissions.cookedData = commonUtils.convertPermissions(permissionsObj);
            commit(constants.MUTATION_SET_CLIENT_ADMIN_DETAILS, response);
            if (options.callback) {
              options.callback();
            }
          }
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  [constants.ACTION_GET_CHANGE_LOG]: ({ commit }, options) => {
    let url = getEndPoints().clientAdmin.filterListChangeLog;
    if (options.clientId) {
      url = getEndPoints().clientAdmin.filterListChangeLogByClientId.replace(
        ":clientId",
        options.clientId
      );
    }
    let params = options.pagination;
    params.limit = options.pagination.per_page;
    params.page = options.pagination.current_page;
    params.links = {};
    params.search = options.searchString ? options.searchString : "";
    makeCall(url, buildOptions("GET", { params: params }), commit).then(
      response => {
        if (response) {
          response.data.forEach(o => {
            if (o.user && o.user.permission) {
              let permissionsObj = [];
              o.user.permission.forEach(item => {
                permissionsObj.push(item.name);
              });
              o.user.permission = commonUtils.convertPermissions(
                permissionsObj
              );
            }
            if (o.old_value && o.old_value.permissions) {
              o.old_value.permissions = commonUtils.convertPermissions(
                o.old_value.permissions
              );
            }
            if (o.new_value && o.new_value.permissions) {
              o.new_value.permissions = commonUtils.convertPermissions(
                o.new_value.permissions
              );
            }
            if (o.old_value === null) {
              o.old_value = {
                username: "",
                last_name: "",
                first_name: "",
                permissions: [],
                phone_number: ""
              };
            }
            if (o.new_value === null) {
              o.new_value = {
                username: "",
                last_name: "",
                first_name: "",
                permissions: [],
                phone_number: ""
              };
            }
          });
          commit(constants.MUTATION_SET_CHANGE_LOG, response);
          if (options.callback) {
            options.callback();
          }
        }
      }
    );
  },

  [constants.ACTION_GET_LIST_BLOCKED_DOMAINS]: ({ commit }, options) => {
    let url = getEndPoints().security.getBlockedDomains;
    url = url.replace(
      "filterStr",
      options.searchString ? options.searchString : ""
    );
    let params = options.pagination;
    params.limit = options.pagination.per_page;
    params.page = options.pagination.current_page;
    params.links = {};
    makeCall(url, buildOptions("GET", { params: params }), commit).then(
      response => {
        if (response) {
          commit(constants.MUTATION_SET_LIST_BLOCKED_DOMAINS, response);
          if (options.callback) {
            options.callback();
          }
        }
      }
    );
  },

  [constants.ACTION_POST_ADD_BLOCKED_DOMAIN]: ({ commit }, options) => {
    makeCall(
      getEndPoints().security.postAddBlockedDomain,
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Add successfully";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        commit(constants.MUTATION_SET_BLOCKED_DOMAIN, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_DELETE_BLOCKED_DOMAIN]: ({ commit }, options) => {
    let url = getEndPoints().security.deleteBlockedDomain.replace(
      ":blockedDomainId",
      options.blockedDomainId
    );
    makeCall(url, buildOptions("DELETE"), commit)
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Delete successfully";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  },

  [constants.ACTION_GET_LIST_USE_POLICY]: ({ commit }, options) => {
    let url = getEndPoints().security.getUsePolicy;
    url = url.replace(
      "filterStr",
      options.searchString ? options.searchString : ""
    );
    let params = options.pagination;
    params.limit = options.pagination.per_page;
    params.page = options.pagination.current_page;
    params.links = {};
    makeCall(url, buildOptions("GET", { params: params }), commit).then(
      response => {
        if (response) {
          commit(constants.MUTATION_SET_LIST_USE_POLICY, response);
          if (options.callback) {
            options.callback();
          }
        }
      }
    );
  },

  [constants.ACTION_GET_ACTIVE_USE_POLICY]: ({ commit }, options) => {
    let url = getEndPoints().security.getActiveUsePolicy;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response) {
        commit(constants.MUTATION_SET_ACTIVE_USE_POLICY, response);
        if (options.callback) {
          options.callback();
        }
      }
    });
  },

  [constants.ACTION_POST_USE_POLICY]: ({ commit }, options) => {
    let url = getEndPoints().security.postUsePolicy;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        options.successMessage = options.successMessage
          ? options.successMessage
          : "Add successfully";
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        if (options.errorHandling) {
          options.errorHandling(error.response.data.error);
        }
      });
  }
};

export const mutations = {
  [constants.MUTATION_SET_ALL_REQUESTS]: (state, payload) => {
    if (payload === null) {
      state.listRequests = constants.DEFAULT_LIST;
    } else {
      payload.data.map(i => {
        if (i.type === "block" || i.type === "reactive") {
          let permissions = [];
          i.new_value.username = i.user.username;
          i.new_value.first_name = i.user.first_name;
          i.new_value.last_name = i.user.last_name;
          i.new_value.phone_number = i.user.phone_number;
          i.new_value.username = i.user.username;
          i.user.permission.forEach(i => {
            permissions.push(i.name);
          });
          i.new_value.permissions = commonUtils.convertPermissions(permissions);
          i.old_value.permissions = commonUtils.convertPermissions(permissions);
        }
      });
      state.listRequests = payload;
    }
  },
  [constants.MUTATION_SET_SINGLE_REQUEST]: (state, payload) => {
    if (payload === null) {
      state.singleRequest = {};
    } else {
      state.singleRequest = payload.data;
    }
  },
  [constants.MUTATION_SET_LIST_CLIENT_PANEL]: (state, payload) => {
    if (payload === null) {
      state.clientsAdminList = constants.DEFAULT_LIST;
    } else {
      state.clientsAdminList = payload;
    }
  },
  [constants.MUTATION_SET_FILTER_LIST_USER]: (state, payload) => {
    if (payload === null) {
      state.clientsAdminList = constants.DEFAULT_LIST;
    } else {
      state.clientsAdminList = payload;
    }
  },
  [constants.MUTATION_SET_CLIENT_ADMIN_DETAILS]: (state, payload) => {
    state.clientAdminDetails = payload.data;
  },
  [constants.MUTATION_SET_REQUEST]: (state, payload) => {
    state.request = payload.data;
  },
  [constants.MUTATION_EDIT_USER]: (state, payload) => {
    state.editUser = payload;
  },
  [constants.MUTATION_SET_CHANGE_LOG]: (state, payload) => {
    if (payload === null) {
      state.listChangeLog = constants.DEFAULT_LIST;
    } else {
      state.listChangeLog = payload;
    }
  },
  [constants.MUTATION_SET_LIST_BLOCKED_DOMAINS]: (state, payload) => {
    if (payload === null) {
      state.listBlockedDomains = constants.DEFAULT_LIST;
    } else {
      state.listBlockedDomains = payload;
    }
  },
  [constants.MUTATION_SET_BLOCKED_DOMAIN]: (state, payload) => {
    if (payload === null) {
      state.newBlockedDomain = {};
    } else {
      state.newBlockedDomain = payload.data;
    }
  },
  [constants.MUTATION_SET_LIST_USE_POLICY]: (state, payload) => {
    if (payload === null) {
      state.listUsePolicy = constants.DEFAULT_LIST;
    } else {
      state.listUsePolicy = payload;
    }
  },
  [constants.MUTATION_SET_ACTIVE_USE_POLICY]: (state, payload) => {
    if (payload === null) {
      state.activeUsePolicy = {};
    } else {
      state.activeUsePolicy = payload;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user-provisioning/index.js